import { buildModelManager } from "../builder.js";
const DefaultPropertyIssueSelection = {
  __typename: true,
  id: true,
  acknowledgedAt: true,
  acknowledgedById: true,
  createdAt: true,
  deletedAt: true,
  description: true,
  escalatedToId: true,
  photos: true,
  propertyId: true,
  relatedWorkItemId: true,
  reportedById: true,
  resolvedAt: true,
  resolvedById: true,
  status: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "propertyIssue";
const pluralModelApiIdentifier = "propertyIssues";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPropertyIssueSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPropertyIssue",
    operationReturnType: "CreatePropertyIssue",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      propertyIssue: { required: false, type: "CreatePropertyIssueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePropertyIssues",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreatePropertyIssuesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "updatePropertyIssue",
    operationReturnType: "UpdatePropertyIssue",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyIssue: { required: false, type: "UpdatePropertyIssueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePropertyIssues",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdatePropertyIssuesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "deletePropertyIssue",
    operationReturnType: "DeletePropertyIssue",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePropertyIssues",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "restorePropertyIssue",
    operationReturnType: "RestorePropertyIssue",
    functionName: "restore",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      propertyIssue: { required: false, type: "RestorePropertyIssueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "bulkRestorePropertyIssues",
    functionName: "bulkRestore",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "restore",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkRestorePropertyIssuesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "upsertPropertyIssue",
    operationReturnType: "UpsertPropertyIssue",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      propertyIssue: { required: false, type: "UpsertPropertyIssueInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePropertyIssueResult": { hasReturnType: false },
      "... on UpdatePropertyIssueResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPropertyIssues",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertPropertyIssuesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPropertyIssueSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "propertyIssueGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PropertyIssueManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPropertyIssueSelection,
  operations
);
export {
  DefaultPropertyIssueSelection,
  PropertyIssueManager
};
//# sourceMappingURL=PropertyIssue.js.map
